module.exports = __webpack_public_path__ + "static/media/coperti.ab189ba1.svg";